export default __webpack_public_path__ + "static/media/abstract-wireframe.6bb0c8cf.jpg";